import React from "react"
import PropTypes from "prop-types"
import Icon from "@kit/design/icon"

const Download = props => {
  Download.propTypes = {
    path: PropTypes.string.isRequired
  }

  return (
    <a
      href={props.path}
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold ml-2 text-sm flex flex-row justify-between items-center self-center hover:bg-gray-100 cursor-pointer rounded-lg py-1 px-2 hover:no-underline"
    >
      <Icon name="download" />
      <span className="ml-2">Download</span>
    </a>
  )
}

const Action = props => {
  Action.propTypes = {
    action: PropTypes.object.isRequired,
    message: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    updatedAtDescription: PropTypes.string,
    updatedAtFormatted: PropTypes.string
  }

  let type

  switch (props.action.type) {
    case "download":
      type = <Download {...props.action} />
  }

  return (
    <li
      className="p-4 flex flex-auto action items-center justify-between"
      data-status={props.status}
    >
      <div>
        <p className="text-sm text-gray-700 font-semibold">{props.message}</p>
        {props.updatedAtDescription && (
          <p title={props.updatedAtFormatted} className="text-xs text-gray-700">
            {props.updatedAtDescription} ago
          </p>
        )}
      </div>
      {type}
    </li>
  )
}

export { Action }
